import { useKeycloak } from "@react-keycloak/web";
import {
  createContext,
  ReactElement,
  ReactNode,
  useEffect,
  useMemo,
  useState,
} from "react";

import { User } from "../generated/gql/graphql";
import useUser from "../hooks/query/user/use-user";

type UserProviderContextType = {
  me?: User;
};

export const UserContext = createContext<UserProviderContextType>({});

type Props = {
  children: ReactNode | ReactNode[];
};

export default function UserProvider(props: Props): ReactElement | null {
  const { children } = props;
  const { keycloak, initialized } = useKeycloak();
  const [user, setUser] = useState<User>();
  const { data, error } = useUser();

  useEffect(() => {
    if (data && data.me) {
      setUser(data.me);
    }
  }, [data]);

  const values = useMemo(
    () => ({
      me: user,
    }),
    [user]
  );

  if (!initialized) return null;

  return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
}
